export const Field = ({ label, hint, required, children, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="block text-xs font-semibold uppercase tracking-wider text-[#57534E] mb-2">
      {label}{required && <span className="text-[#9F7E44]"> *</span>}
    </span>
    {children}
    {hint && <span className="block mt-1.5 text-xs text-[#847F77]">{hint}</span>}
  </label>
);

export const Select = ({ options, placeholder = "Select…", testId, ...props }) => (
  <select data-testid={testId} className="field-input field-select" {...props}>
    <option value="">{placeholder}</option>
    {options.map((o) => <option key={o} value={o}>{o}</option>)}
  </select>
);

export const Chips = ({ options, value, onChange, testIdPrefix }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((o, i) => {
      const on = value.includes(o);
      return (
        <button type="button" key={o} data-testid={`${testIdPrefix}-${i}`}
          onClick={() => onChange(on ? value.filter((v) => v !== o) : [...value, o])}
          className={`px-3 py-1.5 text-xs border transition-colors duration-200 ${on ? "bg-[#121417] text-white border-[#121417]" : "bg-white text-[#57534E] border-[#E4E1D9] hover:border-[#9F7E44]"}`}>
          {o}
        </button>
      );
    })}
  </div>
);

export const SubmitButton = ({ loading, children, testId, className = "" }) => (
  <button type="submit" disabled={loading} data-testid={testId}
    className={`inline-flex items-center justify-center h-12 px-8 bg-[#121417] text-white text-sm font-medium tracking-wide hover:bg-[#9F7E44] disabled:opacity-60 transition-colors duration-300 ${className}`}>
    {loading ? "Please wait…" : children}
  </button>
);
